import { render, staticRenderFns } from "./LinkSideMenu.vue?vue&type=template&id=663173de&scoped=true&lang=pug"
import script from "./LinkSideMenu.vue?vue&type=script&lang=ts"
export * from "./LinkSideMenu.vue?vue&type=script&lang=ts"
import style0 from "./LinkSideMenu.vue?vue&type=style&index=0&id=663173de&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663173de",
  null
  
)

export default component.exports